import { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import PermissionGate from "../layout/PermissionGate";

const PricingSheet = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState({});
  const [models, setModels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("token");

  const fetchPricingModels = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}pricing/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setModels(res.data.data);
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const processData = (type, event, field) => {
    if (type === "text") {
      const value = event.target.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "select") {
      const value = event.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
  };
  const generateSheet = (event) => {
    event.preventDefault();
    const errors = {};
    if (data.name === undefined || data.name === "") {
      errors["name"] = "Please enter name";
    }
    if (data.model === undefined || data.model === "") {
      errors["model"] = "Please select pricing model";
    }
    if (data.latitude === undefined || data.latitude === "") {
      errors["latitude"] = "Please enter latitude";
    }
    if (data.longitude === undefined || data.longitude === "") {
      errors["longitude"] = "Please enter longitude";
    }
    setError({ ...errors });
    if (
      errors.name === undefined &&
      errors.model === undefined &&
      errors.latitude === undefined &&
      errors.longitude === undefined
    ) {
      setIsLoading(true);
      axios
        .post(`${process.env.REACT_APP_API_ENDPOINT}pricing/generate`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        })
        .then((res) => {
          if (res) {
            const url = window.URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `pricing_sheet_${Date.now()}.pdf`);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            reset();
            setIsLoading(false);
          }
        })
        .catch(console.error);
    }
  };
  const reset = () => {
    setData({});
    setError({});
  };

  useEffect(() => {
    fetchPricingModels();
  }, []);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Pricing Sheet
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <form autoComplete="off" onSubmit={(e) => generateSheet(e)}>
                  <div className="row g-5 g-lg-10 mb-5">
                    {/*begin::Card*/}
                    <PermissionGate required={`download_pricing_sheet`}>
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">
                            Download Pricing Sheet
                          </div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-12 mb-3 fv-row">
                              <label className="form-label required">
                                Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter name"
                                value={data?.name ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "name");
                                }}
                              />
                              {error.name !== undefined && error.name !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.name}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-12 mb-3">
                              <label className="form-label required">
                                Select Pricing Model
                              </label>
                              <Select
                                className="react-select-styled react-select-bordered"
                                classNamePrefix="react-select"
                                value={
                                  data.model === undefined
                                    ? null
                                    : models?.filter(
                                        (model) => model?.value === data?.model
                                      )
                                }
                                onChange={(e) => {
                                  processData("select", e, "model");
                                }}
                                options={models}
                                placeholder="Select an option"
                              />
                              {error.model !== undefined &&
                              error.model !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.model}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label required">
                                Latitude
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter latitude"
                                value={data?.latitude ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "latitude");
                                }}
                              />
                              {error.latitude !== undefined &&
                              error.latitude !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.latitude}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label required">
                                Longitude
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter longitude"
                                value={data?.longitude ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "longitude");
                                }}
                              />
                              {error.longitude !== undefined &&
                              error.longitude !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.longitude}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        {/*end::Card body*/}
                        <div className="card-footer text-end">
                          <button
                            onClick={reset}
                            className="btn btn-danger"
                            type="button"
                          >
                            <i className="ki-duotone ki-wrench fs-1">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                            Reset
                          </button>
                          <button
                            className="btn btn-success ms-2"
                            type="submit"
                          >
                            <i className="ki-duotone ki-cloud-download fs-1">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                            Download
                          </button>
                        </div>
                      </div>
                    </PermissionGate>
                    {/*end::Card*/}
                  </div>
                </form>
              </div>
              {/*end::Post*/}
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default PricingSheet;
